module.exports = __webpack_public_path__ + "static/media/foooter_code.6b5a9b90.jpg";